import type { Slide } from '@features/powerpoint';
import type { BuildPresentationV2Props } from './build-presentation';
import { executiveSummarySlideV2 } from '../../../../slides/executive-summary-slide-v2';
import { NEWLINE_REGEX } from '../../../../domain/key-takeaways';

export const executiveSummarySlideFromPropsV2 = (
  props: BuildPresentationV2Props,
  slideMaster: string
): Slide[] =>
  props.customFields.includedSlides.overall.executiveSummary
    ? [
        executiveSummarySlideV2({
          slideMaster,
          rsaKeyTakeaways: props.customFields.summary.split(NEWLINE_REGEX),
          ftaKeyTakeaways: [],
        }),
      ]
    : [];
